import { CircularProgress, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Loader = () => {
    const theme = useTheme();
    return (
        <Stack justifyContent='center' alignItems='center' width='100%'>
            <CircularProgress sx={{ color: theme.palette.customColors.purple }} />
        </Stack>
    );
};

export default Loader;
